import React, { useCallback } from "react";
import styles from "./PhoneField.module.scss";
import { PhoneNumberTextField } from "@bale/ui";
import { strings } from "intl/fa";
import { digitsToHindi } from "@bale/utils";

interface Props {
  value: string;
  onChange: (phone: string) => void;
  placeholder?: string;
  countryCode?: string;
  onEnter?: () => void;
  error?: string;
}

export const PhoneField: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const handleKeyPress = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (event.key === "Enter" && props?.onEnter) {
        props.onEnter();
      }
    },
    [props.onEnter]
  );

  return (
    <>
      <PhoneNumberTextField
        label={strings.login.phone.label}
        data-testid="phone-input"
        placeholder={strings.login.phone.placeholder}
        prefixNumber={
          digitsToHindi(props.countryCode) || strings.login.phone.prefix
        }
        autoFocus
        {...props}
        onKeyDown={handleKeyPress}
        maxLength={props.value.startsWith("۰۹") ? 11 : 10}
      />
    </>
  );
};
